import { ClaimingDialogActions } from '@app/api/models/claiming.models';

export interface CarouselStep {
  title: string;
  imageUrl: string;
  description: string;
}

export interface StepOtherOption {
  buttonText: string;
  buttonHeader?: string;
  action: ClaimingDialogActions;
}

export interface CarouselSlideMultipleSteps {
  steps: CarouselStep[];
}

export interface BreakPoints {
  sm: string;
  md: string;
  lg: string;
  xl: string;
}

export const ScreenBreakpoints: BreakPoints = {
  sm: '(max-width: 576px)',
  md: '(max-width: 768px)',
  lg: '(max-width: 992px)',
  xl: '(min-width: 1200px)',
};

export enum ScreenSizeEnums {
  LargeScreen = 'LARGE_SCREEN',
  MediumScreen = 'MEDIUM_SCREEN',
  SmallScreen = 'SMALL_SCREEN',
}

/**
 * Creates a list of double step slides. Used on medium size devices
 * In case the last slide only has 1 step, then the last step of the previous slide will be duplicated
 * on the last slide.
 */
export const createDoubleCardSlides = (slides: CarouselStep[]) => {
  const steps = [...slides];
  const carouselSlides: CarouselSlideMultipleSteps[] = [];

  while (steps.length) {
    carouselSlides.push({ steps: steps.splice(0, 2) });
  }

  const lastSlideStepsLength = carouselSlides[carouselSlides.length - 1].steps.length;
  if (carouselSlides.length && lastSlideStepsLength === 1) {
    const lastSlide: CarouselSlideMultipleSteps = carouselSlides[carouselSlides.length - 1];
    const penultimateSlide: CarouselSlideMultipleSteps = carouselSlides[carouselSlides.length - 2];
    lastSlide.steps.unshift(penultimateSlide.steps[penultimateSlide.steps.length - 1]);
  }

  return carouselSlides;
};
